import { isBefore } from 'date-fns'
import { isEmpty } from 'lodash'
import { AllClinicsAvailabilitiesGroupedByPeriod } from '@context/AppointmentCalendarContext/types'

export const hasAvailabilitiesBefore = (
  periodRangeStart: string | undefined,
  availabilitiesGrouped: AllClinicsAvailabilitiesGroupedByPeriod | undefined
) => {
  if (!periodRangeStart || isEmpty(availabilitiesGrouped)) return false
  const hasSomeAvailabilitiesBefore = Object.values(availabilitiesGrouped).some((clinicAvailabilities) =>
    clinicAvailabilities.some((week) =>
      week.some((day) => isBefore(new Date(day.date), new Date(periodRangeStart)) && day.availabilities.length > 0)
    )
  )

  return hasSomeAvailabilitiesBefore
}
